import React from 'react';

import PropTypes from 'prop-types';

import { useCurrentProjectId } from '@adsk/alloy-provider';
import Theme from '@adsk/alloy-react-theme';

import EntityMenuItem from '../../EntityMenuItem';

const PhotoEntityCellItem = ({ entity, ...rest }) => {
  const projectId = useCurrentProjectId();
  const { title, id } = entity;
  const url = `/build/photos/projects/${projectId}/photos/${id}`;
  const label = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span style={{ paddingLeft: 3, color: Theme.colors.charcoal700 }}>
        {title}
      </span>
    </div>
  );

  return <EntityMenuItem label={label} link={url} {...rest} />;
};

PhotoEntityCellItem.propTypes = {
  entity: PropTypes.shape({
    title: PropTypes.string,
    createdAt: PropTypes.string,
    takenOn: PropTypes.string,
    takenBy: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
    }),
    thumbnailUrl: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
};
export default PhotoEntityCellItem;
